import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { HttpClient } from "@angular/common/http";
import { IEnglishProficiencyAPI } from "../../models";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class EnglishProficiencyService {
  constructor(private http: HttpClient) {}

  getEnglishProficiency = (): Observable<IEnglishProficiencyAPI> => {
    return this.http.get(
      `${environment.apiUrl}/getEnglishProficiency`
    ) as Observable<IEnglishProficiencyAPI>;
  };

  postEnglishProficiency = (
    englishProficiency: IEnglishProficiencyAPI
  ): Observable<IEnglishProficiencyAPI> => {
    return this.http.post(
      `${environment.apiUrl}/AddEnglishProficiency`,
      englishProficiency
    ) as Observable<IEnglishProficiencyAPI>;
  };
}
